import React, {
  MouseEvent,
} from 'react';
import clsx from 'clsx';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Tooltip from 'core/components/Tooltip';
import DragNDropIcon from 'core/icons/dragNDrop';
import Tag from 'core/components/Tag';

type Parts = 'root' | 'chip' | 'text' | 'icon';

type Props = {
  value: string;
  className?: string;
  classes?: Partial<Record<Parts, string>>;
  onClose?: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  draggable?: boolean;
};

export default function Chip({
  value,
  onClose: onRemove,
  classes,
  disabled,
  draggable = false,
}: Props) {
  return (
    <div
      className={clsx('flex w-full gap-2 items-center', classes?.root)}
      data-nw-attr={value}
    >
      {!disabled && draggable && <DragNDropIcon className="!h-4 !w-4" />}
      <Tag
        defaultColor="bg-blue-200 text-blue-500 font-semibold"
        className="flex items-center max-w-full justify-between"
      >
        <span className="flex-1 truncate">{value}</span>
        {!disabled && (
          <Tooltip title="Remove">
            <IconButton
              size="small"
              className="!py-0.5 !px-0 w-4"
              onClick={onRemove}
            >
              <CloseIcon className={clsx('!w-4 !h-4', classes?.icon)} color="warning" />
            </IconButton>
          </Tooltip>
        )}
      </Tag>
    </div>
  );
}
